import React, { useEffect, useState } from 'react';
import api from '../services/api';

const hoje = () => new Date().toISOString().split('T')[0];

const statusEntregaOpcoes = [
  'Aguardando coleta',
  'Coletado',
  'Em transporte',
  'Saiu para entrega',
  'Entregue'
];

export default function Contratos() {
  const [contratos, setContratos] = useState([]);
  const [frota, setFrota] = useState([]);
  const [motoristas, setMotoristas] = useState([]);

  const [cliente, setCliente] = useState('');
  const [origem, setOrigem] = useState('');
  const [destino, setDestino] = useState('');
  const [data, setData] = useState(hoje());
  const [valor, setValor] = useState('');
  const [veiculoId, setVeiculoId] = useState('');
  const [motoristaId, setMotoristaId] = useState('');
  const [status, setStatus] = useState('Ativo');

  const [codigoRastreio, setCodigoRastreio] = useState('');
  const [previsaoEntrega, setPrevisaoEntrega] = useState('');
  const [statusEntrega, setStatusEntrega] = useState('Aguardando coleta');
  const [rastreioPublico, setRastreioPublico] = useState(true);

  const [editandoId, setEditandoId] = useState(null);
  const [salvando, setSalvando] = useState(false);

  useEffect(() => {
    carregarDados();
  }, []);

  const carregarDados = async () => {
    try {
      const [resContratos, resFrota, resMotoristas] = await Promise.all([
        api.get('/contratos'),
        api.get('/frota'),
        api.get('/motoristas')
      ]);

      setContratos(Array.isArray(resContratos.data) ? resContratos.data : []);
      setFrota(Array.isArray(resFrota.data) ? resFrota.data : []);
      setMotoristas(Array.isArray(resMotoristas.data) ? resMotoristas.data : []);
    } catch (err) {
      console.error('Erro ao carregar dados:', err);
      alert('Não foi possível carregar contratos, frota ou motoristas.');
    }
  };

  const salvarContrato = async (e) => {
    e.preventDefault();

    const dados = {
      cliente: cliente.trim(),
      origem: origem.trim(),
      destino: destino.trim(),
      data: data || hoje(),
      valor: parseFloat(valor) || 0,
      veiculo_id: veiculoId,
      motorista_id: motoristaId,
      veiculo_motorista: `${veiculoId} - ${motoristaId}`,
      status,
      previsao_entrega: previsaoEntrega,
      status_entrega: statusEntrega,
      rastreio_publico: rastreioPublico
    };

    if (!editandoId) {
      dados.id = Date.now().toString();
    }

    setSalvando(true);

    try {
      let response;

      if (editandoId) {
        response = await api.put(`/contratos/${editandoId}`, dados);
      } else {
        response = await api.post('/contratos', dados);
      }

      const resultado = response.data || {};
      const codigoGerado = resultado.codigo_rastreio || codigoRastreio;

      await carregarDados();
      limparFormulario();

      if (codigoGerado) {
        alert(
          `Contrato salvo com sucesso!\n\n` +
          `Código de rastreio: ${codigoGerado}`
        );
      } else {
        alert('Contrato salvo com sucesso! A receita será lançada no Financeiro após a confirmação da entrega.');
      }
    } catch (err) {
      console.error('Erro ao salvar contrato:', err.response || err);
      alert(
        err.response?.data?.detail ||
        err.message ||
        'Erro de conexão ao salvar contrato.'
      );
    } finally {
      setSalvando(false);
    }
  };

  const editarContrato = (c) => {
    setEditandoId(c.id);
    setCliente(c.cliente || '');
    setOrigem(c.origem || '');
    setDestino(c.destino || '');
    setData(c.data || hoje());
    setValor(c.valor ?? '');
    setVeiculoId(c.veiculo_id || '');
    setMotoristaId(c.motorista_id || '');
    setStatus(c.status || 'Ativo');

    setCodigoRastreio(c.codigo_rastreio || '');
    setPrevisaoEntrega(c.previsao_entrega || '');
    setStatusEntrega(c.status_entrega || 'Aguardando coleta');
    setRastreioPublico(Number(c.rastreio_publico) === 1);

    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const excluirContrato = async (id) => {
    if (!window.confirm('Deseja realmente excluir este contrato?')) return;

    try {
      await api.delete(`/contratos/${id}`);
      await carregarDados();

      if (editandoId === id) {
        limparFormulario();
      }
    } catch (err) {
      console.error('Erro ao excluir:', err.response || err);
      alert(
        err.response?.data?.detail ||
        'Erro de conexão ao excluir contrato.'
      );
    }
  };

  const copiarCodigo = async (codigo) => {
    if (!codigo) return;

    try {
      await navigator.clipboard.writeText(codigo);
      alert(`Código ${codigo} copiado.`);
    } catch {
      window.prompt('Copie o código de rastreio:', codigo);
    }
  };

  const limparFormulario = () => {
    setEditandoId(null);
    setCliente('');
    setOrigem('');
    setDestino('');
    setData(hoje());
    setValor('');
    setVeiculoId('');
    setMotoristaId('');
    setStatus('Ativo');

    setCodigoRastreio('');
    setPrevisaoEntrega('');
    setStatusEntrega('Aguardando coleta');
    setRastreioPublico(true);
  };

  const confirmarEntrega = async (contrato) => {
    if (!window.confirm(
      `Confirmar a entrega do contrato ${contrato.codigo_rastreio || contrato.id}?`
    )) return;

    try {
      await api.post(`/contratos/${contrato.id}/confirmar-entrega`);
      await carregarDados();
      alert('Entrega confirmada. O cliente já visualizará o status Entregue.');
    } catch (err) {
      console.error('Erro ao confirmar entrega:', err.response || err);
      alert(
        err.response?.data?.detail ||
        'Não foi possível confirmar a entrega.'
      );
    }
  };

  return (
    <div style={{ padding: '20px', color: '#fff' }}>
      <div style={cabecalhoStyle}>
        <div>
          <h2 style={{ margin: 0 }}>Contratos & Rotas Operacionais</h2>
          <p style={subtituloStyle}>
            Cadastre a operação, vincule veículo e motorista e acompanhe o
            rastreamento público da entrega.
          </p>
        </div>
      </div>

      <form onSubmit={salvarContrato} style={formStyle}>
        <div style={secaoTituloStyle}>Dados do contrato</div>

        <input
          type="text"
          placeholder="Cliente"
          value={cliente}
          onChange={(e) => setCliente(e.target.value)}
          required
          style={inputStyle}
        />

        <input
          type="text"
          placeholder="Origem"
          value={origem}
          onChange={(e) => setOrigem(e.target.value)}
          required
          style={inputStyle}
        />

        <input
          type="text"
          placeholder="Destino"
          value={destino}
          onChange={(e) => setDestino(e.target.value)}
          required
          style={inputStyle}
        />

        <label style={labelStyle}>
          <span>Data do contrato</span>
          <input
            type="date"
            value={data}
            onChange={(e) => setData(e.target.value)}
            required
            style={inputStyle}
          />
        </label>

        <input
          type="number"
          step="0.01"
          min="0"
          placeholder="Valor (R$)"
          value={valor}
          onChange={(e) => setValor(e.target.value)}
          required
          style={inputStyle}
        />

        <select
          value={status}
          onChange={(e) => setStatus(e.target.value)}
          style={inputStyle}
        >
          <option value="Ativo">Contrato ativo</option>
          <option value="Concluído">Contrato concluído</option>
          <option value="Cancelado">Contrato cancelado</option>
        </select>

        <select
          value={veiculoId}
          onChange={(e) => setVeiculoId(e.target.value)}
          style={inputStyle}
          required
        >
          <option value="">Selecione o Veículo</option>
          {frota.map((v) => (
            <option key={v.id || v.placa} value={v.placa}>
              {v.placa} - {v.modelo}
            </option>
          ))}
        </select>

        <select
          value={motoristaId}
          onChange={(e) => setMotoristaId(e.target.value)}
          style={inputStyle}
          required
        >
          <option value="">Selecione o Motorista</option>
          {motoristas.map((m) => (
            <option key={m.id || m.nome} value={m.nome}>
              {m.nome}
            </option>
          ))}
        </select>

        <div style={secaoTituloStyle}>Rastreamento da entrega</div>

        <div style={codigoBoxStyle}>
          <span style={campoTituloStyle}>Código de rastreio</span>
          <strong style={codigoStyle}>
            {codigoRastreio || 'Gerado automaticamente ao salvar'}
          </strong>
          {codigoRastreio && (
            <button
              type="button"
              onClick={() => copiarCodigo(codigoRastreio)}
              style={btnCopiar}
            >
              Copiar código
            </button>
          )}
        </div>

        <label style={labelStyle}>
          <span>Previsão de entrega</span>
          <input
            type="date"
            value={previsaoEntrega}
            onChange={(e) => setPrevisaoEntrega(e.target.value)}
            style={inputStyle}
          />
        </label>

        <label style={labelStyle}>
          <span>Status da entrega</span>
          <select
            value={statusEntrega}
            onChange={(e) => setStatusEntrega(e.target.value)}
            style={inputStyle}
          >
            {statusEntregaOpcoes.map((opcao) => (
              <option key={opcao} value={opcao}>
                {opcao}
              </option>
            ))}
          </select>
        </label>

        <label style={checkBoxContainerStyle}>
          <input
            type="checkbox"
            checked={rastreioPublico}
            onChange={(e) => setRastreioPublico(e.target.checked)}
            style={{ width: '18px', height: '18px', cursor: 'pointer' }}
          />
          <div>
            <strong style={{ display: 'block' }}>
              Permitir rastreamento público
            </strong>
            <span style={checkHintStyle}>
              Quando ativo, o cliente poderá consultar este código no site.
            </span>
          </div>
        </label>

        <div style={acoesFormularioStyle}>
          <button
            type="submit"
            style={{
              ...btnSalvar,
              opacity: salvando ? 0.65 : 1,
              cursor: salvando ? 'wait' : 'pointer'
            }}
            disabled={salvando}
          >
            {salvando
              ? 'Salvando...'
              : editandoId
                ? 'Atualizar Contrato'
                : 'Salvar Contrato'}
          </button>

          {editandoId && (
            <button
              type="button"
              onClick={limparFormulario}
              style={btnCancelar}
              disabled={salvando}
            >
              Cancelar
            </button>
          )}
        </div>
      </form>

      <div style={tabelaContainerStyle}>
        <table style={tableStyle}>
          <thead>
            <tr style={theadRowStyle}>
              <th style={thStyle}>Cliente</th>
              <th style={thStyle}>Origem / Destino</th>
              <th style={thStyle}>Veículo / Motorista</th>
              <th style={thStyle}>Rastreio</th>
              <th style={thStyle}>Entrega</th>
              <th style={thStyle}>Valor</th>
              <th style={thStyle}>Contrato</th>
              <th style={thStyle}>Ações</th>
            </tr>
          </thead>

          <tbody>
            {contratos.length === 0 ? (
              <tr>
                <td colSpan="8" style={vazioStyle}>
                  Nenhum contrato cadastrado.
                </td>
              </tr>
            ) : (
              contratos.map((c) => (
                <tr key={c.id} style={tbodyRowStyle}>
                  <td style={tdStyle}>
                    <strong>{c.cliente}</strong>
                  </td>

                  <td style={tdStyle}>
                    <div>{c.origem}</div>
                    <div style={rotaDestinoStyle}>➜ {c.destino}</div>
                  </td>

                  <td style={tdStyle}>
                    <div>{c.veiculo_id || 'Não vinculado'}</div>
                    <div style={linhaSecundariaStyle}>
                      {c.motorista_id || 'Motorista não vinculado'}
                    </div>
                  </td>

                  <td style={tdStyle}>
                    <button
                      type="button"
                      onClick={() => copiarCodigo(c.codigo_rastreio)}
                      style={codigoTabelaStyle}
                      title="Clique para copiar"
                    >
                      {c.codigo_rastreio || 'Sem código'}
                    </button>
                    <div
                      style={{
                        ...linhaSecundariaStyle,
                        color:
                          Number(c.rastreio_publico) === 1
                            ? '#5ed08a'
                            : '#f6b85a'
                      }}
                    >
                      {Number(c.rastreio_publico) === 1
                        ? 'Público'
                        : 'Desativado'}
                    </div>
                  </td>

                  <td style={tdStyle}>
                    <strong>{c.status_entrega || 'Aguardando coleta'}</strong>
                    <div style={linhaSecundariaStyle}>
                      Previsão: {formatarData(c.previsao_entrega)}
                    </div>
                  </td>

                  <td style={tdStyle}>{formatarMoeda(c.valor)}</td>
                  <td style={tdStyle}>{c.status}</td>

                  <td style={tdStyle}>
                    {Number(c.entrega_informada || 0) === 1 &&
                      c.status_entrega !== 'Entregue' && (
                        <div style={{
                          marginBottom: '8px',
                          padding: '8px 10px',
                          borderRadius: '6px',
                          background: '#3a2d00',
                          border: '1px solid #8a6a00',
                          color: '#FFD60A',
                          fontSize: '11px',
                          fontWeight: '800'
                        }}>
                          ⚠ Entrega aguardando confirmação
                        </div>
                      )}

                    <div style={{ ...acoesTabelaStyle, flexWrap: 'wrap' }}>
                      {Number(c.entrega_informada || 0) === 1 &&
                        c.status_entrega !== 'Entregue' && (
                          <button
                            type="button"
                            onClick={() => confirmarEntrega(c)}
                            style={{
                              padding: '7px 10px',
                              border: 'none',
                              borderRadius: '5px',
                              background: '#32D74B',
                              color: '#000',
                              fontWeight: '900',
                              cursor: 'pointer'
                            }}
                          >
                            Confirmar entrega
                          </button>
                        )}

                      <button
                        type="button"
                        onClick={() => editarContrato(c)}
                        style={btnEditar}
                      >
                        Editar
                      </button>
                      <button
                        type="button"
                        onClick={() => excluirContrato(c.id)}
                        style={btnExcluir}
                      >
                        Excluir
                      </button>
                    </div>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}

function formatarData(valor) {
  if (!valor) return 'Não informada';

  const partes = valor.split('-');
  if (partes.length !== 3) return valor;

  return `${partes[2]}/${partes[1]}/${partes[0]}`;
}

function formatarMoeda(valor) {
  const numero = Number(valor) || 0;

  return numero.toLocaleString('pt-BR', {
    style: 'currency',
    currency: 'BRL'
  });
}

const cabecalhoStyle = {
  marginBottom: '18px'
};

const subtituloStyle = {
  margin: '8px 0 0',
  color: '#9ba7b4',
  fontSize: '14px',
  lineHeight: 1.5
};

const formStyle = {
  background: '#1e1e1e',
  padding: '18px',
  borderRadius: '10px',
  marginBottom: '24px',
  display: 'grid',
  gridTemplateColumns: 'repeat(auto-fit, minmax(230px, 1fr))',
  gap: '12px',
  border: '1px solid #2f2f2f'
};

const secaoTituloStyle = {
  gridColumn: '1 / -1',
  color: '#8ebdff',
  fontSize: '12px',
  fontWeight: 'bold',
  textTransform: 'uppercase',
  letterSpacing: '0.08em',
  marginTop: '2px'
};

const labelStyle = {
  display: 'flex',
  flexDirection: 'column',
  gap: '6px',
  color: '#c4ccd4',
  fontSize: '12px'
};

const inputStyle = {
  width: '100%',
  minHeight: '42px',
  padding: '10px',
  background: '#2d2d2d',
  border: '1px solid #444',
  color: '#fff',
  borderRadius: '6px',
  outline: 'none',
  boxSizing: 'border-box'
};

const codigoBoxStyle = {
  minHeight: '72px',
  padding: '10px 12px',
  background: '#151f2b',
  border: '1px solid #31506f',
  borderRadius: '7px',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  gap: '5px'
};

const campoTituloStyle = {
  color: '#90a1b2',
  fontSize: '11px'
};

const codigoStyle = {
  color: '#fff',
  fontSize: '15px',
  letterSpacing: '0.06em'
};

const btnCopiar = {
  alignSelf: 'flex-start',
  padding: '5px 8px',
  background: '#263d55',
  color: '#dcecff',
  border: '1px solid #345474',
  borderRadius: '5px',
  cursor: 'pointer',
  fontSize: '11px'
};

const checkBoxContainerStyle = {
  minHeight: '72px',
  padding: '11px 12px',
  background: '#252525',
  border: '1px solid #3c3c3c',
  borderRadius: '7px',
  display: 'flex',
  alignItems: 'center',
  gap: '10px',
  cursor: 'pointer'
};

const checkHintStyle = {
  display: 'block',
  marginTop: '4px',
  color: '#8f9aa6',
  fontSize: '11px',
  lineHeight: 1.4
};

const acoesFormularioStyle = {
  gridColumn: '1 / -1',
  display: 'flex',
  gap: '10px',
  flexWrap: 'wrap',
  marginTop: '4px'
};

const btnSalvar = {
  padding: '11px 20px',
  background: '#007AFF',
  color: '#fff',
  border: 'none',
  borderRadius: '6px',
  fontWeight: 'bold'
};

const btnCancelar = {
  padding: '11px 20px',
  background: '#555',
  color: '#fff',
  border: 'none',
  borderRadius: '6px',
  cursor: 'pointer'
};

const tabelaContainerStyle = {
  width: '100%',
  overflowX: 'auto',
  borderRadius: '10px',
  border: '1px solid #303030'
};

const tableStyle = {
  width: '100%',
  minWidth: '1120px',
  borderCollapse: 'collapse',
  background: '#1e1e1e'
};

const theadRowStyle = {
  background: '#292929',
  textAlign: 'left'
};

const tbodyRowStyle = {
  borderBottom: '1px solid #333'
};

const thStyle = {
  padding: '12px',
  borderBottom: '2px solid #444',
  color: '#cbd3db',
  fontSize: '12px',
  whiteSpace: 'nowrap'
};

const tdStyle = {
  padding: '12px',
  verticalAlign: 'top',
  fontSize: '13px'
};

const rotaDestinoStyle = {
  marginTop: '5px',
  color: '#aab4bd'
};

const linhaSecundariaStyle = {
  marginTop: '5px',
  color: '#8d99a5',
  fontSize: '11px'
};

const codigoTabelaStyle = {
  padding: 0,
  background: 'transparent',
  border: 'none',
  color: '#7db5ff',
  fontWeight: 'bold',
  cursor: 'pointer',
  letterSpacing: '0.03em',
  textAlign: 'left'
};

const acoesTabelaStyle = {
  display: 'flex',
  gap: '6px'
};

const btnEditar = {
  padding: '6px 10px',
  background: '#f0ad4e',
  color: '#fff',
  border: 'none',
  borderRadius: '4px',
  cursor: 'pointer'
};

const btnExcluir = {
  padding: '6px 10px',
  background: '#d9534f',
  color: '#fff',
  border: 'none',
  borderRadius: '4px',
  cursor: 'pointer'
};

const vazioStyle = {
  padding: '28px',
  textAlign: 'center',
  color: '#8f9aa6'
};
